$('.products-slider').slick({
	infinite: true,
	slidesToShow: 1,
	prevArrow: '.products-prev',
	nextArrow: '.products-next',
	autoplay: true,
	autosped: 5000,
    fade: true,
	speed: 100,
});

$('.reviews-slider').slick({
	infinite: true,
	slidesToShow: 1,
	prevArrow: '.reviews-prev',
	nextArrow: '.reviews-next',
});

$('.products-tab').click(function(){
    $('.products-slider').slick('slickGoTo', $(this).data('slide'));
    $('.products-tab').removeClass('products-tab_active');
    $(this).addClass('products-tab_active');
});


$('.products-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.products-tab').removeClass('products-tab_active');
    $('.products-tab[data-slide = '+ currentSlide +']').addClass('products-tab_active');
 });



 $('.when-tab').click(function(e) {
     let tab = $(this).data('tab');
    $('.when-tab').removeClass('when-tab_active');
    $(this).addClass('when-tab_active');
	if($(window).width() > 980) {
		$('.when-item').removeClass('product-when-active').hide();
		$('.when-item[data-when= '+ tab +']').addClass('product-when-active').show();
	} else {
		$('.when-item').hide();
		$('.when-item[data-when= '+ tab +']').fadeIn();
	}

	if($(window).width() < 980) {
		$('.popup-frame').css("display", "flex").hide().fadeIn();
		$('.popup-when').fadeIn();
	}
});

if($(window).width() < 980) {
	$('.when-tab').removeClass('when-tab_active');
}

$('.why-item').click(function(e) {
	let tab = $(this).data('why');

   if($(window).width() < 980) {
		$('.popup-why-item').hide();
		$('.popup-why-item[data-why= '+ tab +']').fadeIn();
	   	$('.popup-frame').css("display", "flex").hide().fadeIn();
	   	$('.popup-why').fadeIn();
   }
});

// $('.product-reviews-slider').slick({
//     infinite: true,
//     slidesToShow: 1,
//     prevArrow: '.product-reviews-prev',
//     nextArrow: '.product-reviews-next',
// });

$('.product-reviews-slider-mobile').slick({
    infinite: true,
    slidesToShow: 1,
    prevArrow: '.product-reviews-prev-mobile',
    nextArrow: '.product-reviews-next-mobile',
});


$('.product-content__header li').click(function(e) {
	let tab = $(this).data('tab');
	$('.product-content__header li').removeClass('product-content_active');
	$(this).addClass('product-content_active');

	$('.product-content__item').hide();
	$('.product-content__item[data-tab= '+ tab +']').fadeIn();
    if (tab == 2) {

        window.dispatchEvent(new Event('resize'));
    }
});

$('.burger').click(function(e) {
	e.preventDefault();
	$('.popup-menu').css("display", "flex").hide().fadeIn();
	$('.menu').addClass('menu_active');
});
$('.menu-close').click(function(e) {
	e.preventDefault();
	$('.popup-menu').delay(100).fadeOut();
	$('.menu').removeClass('menu_active');
});

$('.js-popup-application').click(function(e) {
	e.preventDefault();
	$('html').addClass('open-frame');
	$('.popup-frame').css("display", "flex").hide().fadeIn();
	$('#send-mail-form').fadeIn();
});

$('.js-popup-product').click(function(e) {
		$('html').addClass('open-frame');
		$('.popup-frame-index').css("display", "flex").hide().fadeIn();
	e.preventDefault();
	if($('.products-tab').hasClass('products-tab_active')) {
		$('.popup-product').fadeIn();
	} else {
		$('.popup-info').fadeIn();
	}

});
$('.header-user.do-login').click(function(e) {
	e.preventDefault();
	$('html').addClass('open-frame');
	$('.popup-frame').css("display", "flex").hide().fadeIn();
	$('.popup-login').fadeIn();
});

var counter = 1;

$('.city-select select').change(function() {
    counter++;
	let city = $(this).find('option:selected').val();
	$('.map-list').hide();
	$('.map-list[data-city= '+ city +']').fadeIn();


	let cords = $('.map-list[data-city= '+ city +']').data('cords');

      $('.maps').remove();
      $('.map-location').append('<div id="map'+ counter +'" class="maps"></div>')
      var map = L.map('map'+ counter + '').setView(cords, 12);

      L.esri.basemapLayer('Streets').addTo(map);

      var icon = L.icon({
      iconUrl: '/images/map.svg',
      iconSize: [24, 24],
      iconAnchor: [7, 16],
      popupAnchor: [0, -11]
      });

	  $('.map-list[data-city= '+ city +'] .js-map-cords').each(function() {
        let cords = $(this).data('cords');
        L.marker(cords, {
          icon: icon
        }).addTo(map);

      });
})

$('.product-plus').click(function() {
    let counterItem = $(this).siblings('.product-number');
    let counter = counterItem.html();
    if(counter > 98) {
        counter = 99;
    } else {
        counter++;
    }
    counter = counterItem.html(counter);
});

$('.product-minus').click(function() {
    let counterItem = $(this).siblings('.product-number');
    let counter = counterItem.html();
    if(counter < 2) {
        counter = 1;
    } else {
        counter--;
    }
    counter = counterItem.html(counter);
});

$('.products-nav-mob:not(.products-nav-mob-header)').click(function(e) {
	e.preventDefault();
	$('.products-nav:not(.products-nav-mob-header)').slideToggle();
});

$('.products-nav li').click(function(e) {
    $(this).closest('.products-nav').slideToggle();;
});

$("body").click(function (e){ // событие клика по веб-документу
	var popup = $(".products-nav"); // тут указываем ID элемента
	if (!popup.is(e.target) // если клик был не по нашему блоку
		&& !$(".products-nav-mob").is(e.target) &&  popup.has(e.target).length === 0) { // и не по его дочерним элементам
			if($(window).width() < 980) {
				$('.products-nav').slideUp();
			}
	}
});

if($(window).width() < 980) {
	$('.how-list-slider').slick({
		infinite: true,
		slidesToShow: 3,
		prevArrow: '.how-list-prev',
		nextArrow: '.how-list-next',
		responsive: [
			    {
			      breakpoint: 700,
			      settings: {
			        slidesToShow: 2,
			      }
			    },
			  ]
	});
}

$('.products-nav_active').click(function(e) {
	e.preventDefault();
	$($('.products-slider')).slick('slickGoTo', 0);
});

var slider = $(".products-slider");
slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	slider.find('.products-slide__info').removeClass('product-info-active');
	slider.find('.products-slide__photo').removeClass('product-photo-active');
	setTimeout(sliderAnimation, 100);

});
function sliderAnimation() {
	slider.find('.products-slide__info').addClass('product-info-active');
	slider.find('.products-slide__photo').addClass('product-photo-active');
}

(function ( $ ) {
    (function () {
        $("body").scroll(function (e) {
            if ($("body").scrollTop() > 150) {
                $(".header").addClass("header-fixed");
                if ($(".header-bar-default-items").is(":visible")) {
                    $(".header-bar-default-items").addClass('fade');
                    $(".header-bar-default-items-sm").addClass('fade');
                    $(".header-bar-default-items-fixed").addClass('mt20');
                }

                setTimeout(function () {
                    $(".header-bar-default-items").hide();
                    $(".header-bar-default-items-sm").hide();
                    if (!$(".header-bar-default-items-fixed").is(":visible") && $("body").scrollTop() > 150 ) {
                        $(".header-bar-default-items-fixed").css("display", "flex");
                        $(".header-bar-default-items-fixed").addClass('show');
                        setTimeout(function () {
                            $(".header-bar-default-items-fixed").removeClass('show');
                            $(".header-bar-default-items-fixed").removeClass('mt20');
                        },505);

                    }
                    $(".header-bar-default-items").removeClass('fade');
                    $(".header-bar-default-items-sm").removeClass('fade');
                },505);

            } else {
                $(".header").removeClass("header-fixed");
                if ($(".header-bar-default-items-fixed").is(":visible")) {
                    $(".header-bar-default-items-fixed").addClass('fade');
                    $(".header-bar-default-items").addClass('mt20');
                    $(".header-bar-default-items-sm").addClass('mt20');
                }
                setTimeout(function () {
                    $(".header-bar-default-items-fixed").hide();
                    $('.products-nav.products-nav-mob-header').hide();
                    if (!$(".header-bar-default-items").is(":visible") && $("body").scrollTop() < 150 ) {
                        $(".header-bar-default-items").css("display", "flex");
                        $(".header-bar-default-items").addClass('show');
                        setTimeout(function () {
                            $(".header-bar-default-items").removeClass('show');
                            $(".header-bar-default-items").removeClass('mt20');
                        },505);
                    }
                    $(".header-bar-default-items-fixed").removeClass('fade');
                },505);
            }
        });

        $('.products-nav-mob.products-nav-mob-header').click(function(e) {
            e.preventDefault();
            $('.products-nav.products-nav-mob-header').slideToggle();
        });

        // Код для плавного перехода по якорным ссылкам
        $(".anchor").click(function (e) {

            let offset = window.innerWidth > 700 ? 101 : 75.59;

            let href = $(this).attr('href').slice(1);
            let top = $("body").scrollTop() + $(href).offset().top - offset;
            $('body,html').animate({scrollTop: top}, 1500);
            e.preventDefault();
        });

        let hash = window.location.hash.substr(1);

        if (hash.length && $("#"+ hash).length) {
            setTimeout(function () {
                let offset = window.innerWidth > 700 ? 101 : 75.59;
                let top = $("body").scrollTop() + $("#" + hash).offset().top - offset;

                $('body,html').animate({scrollTop: top}, 1000);
            }, 500 );
        }
    }());
}( jQuery ));

